import { Bar } from "@ant-design/plots";

import React from "react";

export const AssessmentResultBarChart = ({ data, title }) => {
  console.log("🚀 ~ AssessmentResultBarChart ~ data:", data);
  const config = {
    data,
    xField: "label",
    yField: "score",
    colorField: "#FF8536",
    paddingRight: 80,
    style: {
      maxWidth: 25,
    },
    markBackground: {
      label: {
        text: ({ originData }) => {
          // return `${(originData.score / 100) * 100}% | ${originData.score}`;
          return `${(originData.score / 100) * 100}%`;
        },
        position: "right",
        dx: 80,
        style: {
          fill: "#aaa",
          fillOpacity: 1,
          fontSize: 14,
        },
      },
      style: {
        fill: "#eee",
      },
    },
    scale: {
      y: {
        domain: [0, 100],
      },
    },
    axis: {
      x: {
        tick: false,
        title: false,
      },
      y: {
        grid: false,
        tick: false,
        label: false,
        title: false,
      },
    },
    interaction: {
      elementHighlightByColor: false,
    },
  };
  return (
    <div className="flex flex-col">
      <h1 className="font-semibold text-lg">{title}</h1>
      <Bar {...config} />
    </div>
  );
};
